import { LOCAL, DAILY, TEST, PRE, PROD } from './types';
function parseHostname(options) {
    let { hostname } = options;
    // 解析用户提供的 hostname
    if (hostname) {
        if (hostname.indexOf('//') !== -1) {
            [, hostname] = hostname.split('//');
        }
        if (hostname.indexOf('/') !== -1) {
            [hostname] = hostname.split('/');
        }
        if (hostname.indexOf(':') !== -1) {
            [hostname] = hostname.split(':');
        }
    }
    else {
        hostname = window.location.hostname;
    }
    return hostname && hostname.trim();
}
function parseCurrentScriptSrc(options) {
    let { currentScriptSrc } = options;
    if (currentScriptSrc) {
        return currentScriptSrc;
    }
    if (window.__CURRENT_SCRIPT_SRC__) {
        currentScriptSrc = window.__CURRENT_SCRIPT_SRC__;
    }
    else if (window.__current_micro_config__ && window.__current_micro_config__.prefix) {
        currentScriptSrc = window.__current_micro_config__.prefix;
    }
    else if (window.document.currentScript) {
        const script = window.document.currentScript;
        currentScriptSrc = script.src;
    }
    return currentScriptSrc && currentScriptSrc.trim();
}
const regIp = /^\d+\.\d+\.\d+\.\d+$/;
export function getCnEnv(options = {}) {
    try {
        // case: 读取外界注入的 window.__CN_ENV__, 优先级最高, 这样也可以在本地 public/index.html 模拟其他环境
        if (typeof window !== 'undefined' && window.__CN_ENV__) {
            return window.__CN_ENV__;
        }
        const hostname = parseHostname(options);
        if (!hostname) {
            return PROD;
        }
        // case: localhost/127.0.0.1
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return LOCAL;
        }
        // case: ip 30.117.72.7
        if (regIp.test(hostname)) {
            return LOCAL;
        }
        const parts = hostname.split('.');
        const head = parts[0] || '';
        const tail = parts[parts.length - 1] || '';
        // case: pre.xxx pre-xxx.yyy pre2-xxx.yyy page-pre.xxxx
        if (head === PRE ||
            head.indexOf(`${PRE}-`) === 0 ||
            head.indexOf(`${PRE}2-`) === 0 ||
            head.indexOf(`page-${PRE}`) === 0) {
            return PRE;
        }
        // case: daily.xxx daily-xxx.yyy page-daily.xxx
        if (head === DAILY ||
            head.indexOf(`${DAILY}-`) === 0 ||
            head.indexOf(`page-${DAILY}`) === 0 ||
            tail === TEST) {
            return DAILY;
        }
        // case: currentScriptSrc
        const currentScriptSrc = parseCurrentScriptSrc(options);
        if (!currentScriptSrc) {
            return PROD;
        }
        if (currentScriptSrc.indexOf('https://g.alicdn.com') === 0 ||
            currentScriptSrc.indexOf('https://cn.alicdn.com') === 0) {
            return PROD;
        }
        if (currentScriptSrc.indexOf('https://dev.g.alicdn.com') === 0 ||
            currentScriptSrc.indexOf('https://assets-daily.cainiao-inc.com') === 0) {
            return DAILY;
        }
    }
    catch (err) {
        // ignore err
    }
    return PROD;
}
/**
 * 判断当前运行环境是否为菜鸟内部环境，即域名以 .cainiao-inc.com 结尾
 * @returns boolean
 */
export function isCnRuntime() {
    const { hostname = '' } = (window === null || window === void 0 ? void 0 : window.location) || {};
    return !!hostname.endsWith('.cainiao-inc.com');
}
export { LOCAL, TEST, DAILY, PRE, PROD, CnEnvOptions } from './types';
